import { useNavigate } from "react-router-dom";
import SearchBar from "./SearchBar";
import styles from "./Hero.module.css";

const TRENDING = [
  "Taylor Swift",
  "Lakers",
  "Hamilton",
  "Drake",
  "Yankees",
  "Wicked",
];

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className={styles.hero}>
      <div className={`container ${styles.inner}`}>
        <p className={styles.kicker}>Live tickets · backed by guarantee</p>
        <h1 className={styles.title}>
          The night out
          <br />
          starts <span className="gradient-text">here.</span>
        </h1>
        <p className={styles.subtitle}>
          Concerts, sports, theater &amp; more. Real seats, instant
          confirmation, no surprise fees at checkout.
        </p>
        <div className={styles.searchWrap}>
          <SearchBar
            large
            onSubmit={(q) => navigate(`/search?q=${encodeURIComponent(q)}`)}
          />
        </div>
        <div className={styles.trending}>
          <span className={styles.trendingLabel}>Trending</span>
          {TRENDING.map((t) => (
            <button
              key={t}
              className={styles.chip}
              onClick={() => navigate(`/search?q=${encodeURIComponent(t)}`)}
            >
              {t}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
